import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ENUMS, REPORT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

export const AggregatorProfitReportConfig = {
	id: DYNAMICLISTS.AGGREGATOR_PROFIT_REPORT,
	columns: [
		{
			Header: 'id',
			accessor: 'id',
			filterType: FilterType.number,
			showCopyButton: true,
			showOnMobile: true,
			show: false
		},
		{
			Header: 'shipmentID',
			accessor: 'shipmentID',
			filterType: FilterType.string,
			showCopyButton: true,
			showOnMobile: true,
			show: true
		},
		{
			Header: 'orderID',
			accessor: 'orderID',
			filterType: FilterType.string,
			showCopyButton: true,
			showOnMobile: true,
			show: false
		},
		{
			Header: 'deliveryCompanyID',
			accessor: 'deliveryCompanyID',
			filterType: FilterType.number,
			showCopyButton: true,
			show: false
		},
		{
			Header: 'deliveryCompanyName',
			accessor: 'deliveryCompanyName',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'clientID',
			accessor: 'clientID',
			filterType: FilterType.string,
			showCopyButton: true,
			show: false
		},
		{
			Header: 'clientName',
			accessor: 'clientName',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'orderWeight',
			accessor: 'orderWeight',
			filterType: FilterType.float,
			show: false
		},
		{
			Header: 'createdDate',
			accessor: 'createdDate',
			filterType: FilterType.date,
			width: 90,
			renderCell: ListComponents.DATETIME
		},
		{
			Header: 'shipmentType',
			accessor: 'shipmentType',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.SHIPMENT_TYPE,
			show: false
		},
		{
			Header: 'dcSettingsID',
			accessor: 'deliveryCompanySettingsID',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'contractName',
			accessor: 'contractName',
			filterType: FilterType.string
		},
		{
			Header: 'shipmentCreatedDate',
			accessor: 'shipmentCreatedDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			show: false
		},
		{
			Header: 'pickupDate',
			accessor: 'pickUpDate',
			filterType: FilterType.date,
			renderCell: ListComponents.DATETIME,
			filterRemovable: false
		},
		{
			Header: 'lastStatusOfShipment',
			accessor: 'lastStatusOfShipment',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.ALL_STATUSES,
			renderCell: ListComponents.STATUS,
			show: false
		},
		{
			Header: 'clientChargedCredit',
			accessor: 'clientChargedCredit',
			filterType: FilterType.float,
			renderCell: ListComponents.CURRENCY
		},
		{
			Header: 'cost',
			accessor: 'costdifference',
			filterType: FilterType.float,
			renderCell: ListComponents.CURRENCY
		},
		{
			Header: 'priceMargin',
			accessor: 'priceMargin',
			filterType: FilterType.float
		},
		{
			Header: 'codMargin',
			accessor: 'codMargin',
			filterType: FilterType.float,
			show: false
		},
		{
			Header: 'originCountry',
			accessor: 'originCountry',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'destinationCountry',
			accessor: 'destinationCountry',
			filterType: FilterType.enum,
			enumName: ENUMS.COUNTRIES,
			showOnMobile: true,
			width: 100,
			show: false
		},
		{
			Header: 'originTier',
			accessor: 'originTier',
			filterType: FilterType.multiSelection,
			show: false
		},
		{
			Header: 'destinationTier',
			accessor: 'destinationTier',
			filterType: FilterType.multiSelection,
			show: false
		},
		{
			Header: 'originCity',
			accessor: 'originCity',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'destinationCity',
			accessor: 'destinationCity',
			filterType: FilterType.string,
			show: false
		},
		{
			Header: 'currency',
			accessor: 'currency',
			filterType: FilterType.enumMulti,
			enumName: ENUMS.CURRENCY,
			show: false
		},
		{
			Header: 'originalWeight',
			accessor: 'originalWeight',
			filterType: FilterType.float
		},
		{
			Header: 'currentRemainingAmount',
			accessor: 'currentRemainingAmount',
			filterType: FilterType.float
		},
		{
			Header: 'remainingBalanceAfterWeightUpdate',
			accessor: 'remainingBalanceAfterWeightUpdate',
			filterType: FilterType.float
		},
		{
			Header: 'weightUpdateCharge',
			accessor: 'weightUpdateCharge',
			filterType: FilterType.float
		},
		{
			Header: 'weightUpdateDate',
			accessor: 'wightUpdateDate',
			filterType: FilterType.date,
			width: 90,
			renderCell: ListComponents.DATETIME
		}
	],

	fetchUrl: REPORT.LIST.GET_AGGREGATOR_PROFIT_REPORT_LIST,
	exportName: 'aggregatorProfitReport'
};

const AggregatorProfitReport = () => {
	const { state } = useLocation();

	const defaultFilters = useMemo(() => {
		if (!state?.data || Object.keys(state?.data)?.length === 0) {
			return [];
		}

		return [
			{
				column: AggregatorProfitReportConfig.columns.find((col) => col.accessor === 'pickUpDate'),
				action: FilterAction.between,
				value: state.data.date
			}
		];
	}, []);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					lightTitle="reports"
					boldTitle="aggregatorOTOProfitReport"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.REPORTS, PATHS.SHIPMENT_REPORTS)}
				/>
			</HeaderContainerFormHeader>

			<DynamicList {...AggregatorProfitReportConfig} defaultFilters={defaultFilters} />
		</div>
	);
};
export default AggregatorProfitReport;
